module.exports = __webpack_public_path__ + "static/media/express.f6a94e9a.svg";